import React, { useEffect, useState } from "react";
import { Tabs, Row, Button, message, Card } from "antd";
// UPDATED: Removed useOutletContext import
// import { useOutletContext } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { EyeOutlined, UserOutlined, TeamOutlined, FileAddOutlined, FireOutlined } from "@ant-design/icons";
import DataTable from "../DataTable/DataTable";
import {
  getPolicyFeature,
  getPolicyFeatureDataCorporate,
} from "../../Action/Actions";
import { getUserData } from "../login/LoginSlice";
// UPDATED: Added imports for Redux financial year state
import { selectFinancialYears, selectSelectedYearId } from "../../Redux/financialYearSlice";
import ModalDisplay from "./ModalDisplay";

const PolicyFeatures = () => {
  // UPDATED: Get financial year details from Redux instead of Context
  const selectedYearId = useSelector(selectSelectedYearId);
  const yearList = useSelector(selectFinancialYears);
  const selectedYear = yearList.find(year => year.id === selectedYearId)?.financial_year || "";

  const dispatch = useDispatch();
  const AuthData = useSelector(getUserData);
  const [activeTab, setActiveTab] = useState("GMC");
  const [policyFeatures, setPolicyFeatures] = useState({});
  const [FilterData, setFilterData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [buttonLoading, setButtonLoading] = useState({});
  const user = useSelector(getUserData);

  const Id = AuthData?.corporate_id;

  // UPDATED: useEffect now depends on selectedYearId from Redux
  useEffect(() => {
    document.title = `Policy Features`;
    // Guard clause to ensure required IDs are present before fetching
    if (Id && selectedYearId) {
      fetchPolicies();
    } else {
      // Clear data if IDs are not available
      setPolicyFeatures({});
      setFilterData([]);
    }
  }, [dispatch, Id, selectedYearId]); // Removed activeTab from dependencies to avoid redundant fetches and potential race conditions

  const fetchPolicies = async () => {
    try {
      setLoading(true);
      const response = await dispatch(getPolicyFeature(Id));
      const policyData = response?.policy_Feature || {};
      setPolicyFeatures(policyData);

      const availableTabs = Object.keys(policyData);
      if (availableTabs.length > 0) {
        // Dynamic tab selection: If current activeTab is not in available data,
        // (like default "GMC" being missing for this corporate)
        // or if activeTab hasn't been set yet, pick the first available one.
        if (!availableTabs.includes(activeTab)) {
          const firstAvailable = availableTabs[0];
          setActiveTab(firstAvailable);
          setFilterData(policyData[firstAvailable] || []);
        } else {
          // If current activeTab is valid, update its data
          setFilterData(policyData[activeTab] || []);
        }
      } else {
        setFilterData([]);
      }
    } catch (error) {
      console.error("Error fetching policies:", error);
      setPolicyFeatures({}); // Clear data on error
      setFilterData([]);
    } finally {
      setLoading(false);
    }
  };

  const showModal = async (record, index) => {
    const { policy_identifier_id } = record;
    setButtonLoading((prev) => ({ ...prev, [index]: true }));

    try {
      const response = await dispatch(getPolicyFeatureDataCorporate(policy_identifier_id, user?.role_id));
      const details = response?.Policy_feature_data || [];

      setSelectedPolicy({ ...record, details });
      setModalVisible(true);
    } catch (error) {
      console.error("Error fetching policy details:", error);
    } finally {
      setButtonLoading((prev) => ({ ...prev, [index]: false }));
    }
  };

  const handleModalClose = () => {
    setModalVisible(false);
    setSelectedPolicy(null);
  };
  const getTabIcon = (type) => {
    switch (type) {
      case "GMC":
        return <TeamOutlined style={{ marginRight: 8 }} />;
      case "GTL":
        return <UserOutlined style={{ marginRight: 8 }} />;
      case "GPA":
        return <TeamOutlined style={{ marginRight: 8 }} />;
      case "Parent policy":
        return <TeamOutlined style={{ marginRight: 8 }} />;
      case "Topup":
        return <FileAddOutlined style={{ marginRight: 8 }} />;
      case "Fire":
        return <FireOutlined style={{ marginRight: 8 }} />;
      default:
        return null;
    }
  };

  const items = Object.keys(policyFeatures).map((key) => ({
    key,
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        {key}
        {getTabIcon(key)}
      </span>
    ),
  }));

  const onChange = (key) => {
    setActiveTab(key);
    setFilterData(policyFeatures[key] || []);
  };

  const columns = [
    {
      title: "SI NO",
      dataIndex: "si_no",
      key: "si_no",
      render: (_, __, index) => index + 1,
    },
    {
      title: "POLICY NUMBER",
      dataIndex: "policy_number",
      key: "policy_number",
      render: (policy_number) =>
        policy_number ? (
          policy_number
        ) : (
          <span
            style={{
              backgroundColor: "yellow",
              padding: "2px 5px",
              borderRadius: "4px",
              display: "inline-block",
            }}
          >
            Policy not yet issued
          </span>
        ),
    },
    {
      title: "SUM INSURED",
      dataIndex: "sum_insured",
      key: "sum_insured",
    },
    {
      title: "QUICK VIEW",
      dataIndex: "action",
      key: "action",
      render: (_, record, index) => (
        <Button
          type="primary"
          className="d-flex"
          icon={<EyeOutlined />}
          onClick={() => showModal(record, index)}
          disabled={!record.policy_number}
          loading={buttonLoading[index] || false}
        >
          Policy Benefit
        </Button>
      ),
    },
  ];

  return (
    <div className="escalation-matrix-container">
      <div className="escalation-heading">Policy Features</div>
      <div className="escalation-content mb-3">
        <Row className="escalation-row-header">
          <span style={{ fontWeight: "700", fontSize: "20px" }}>
            {user?.corporate_name || "Guest"}
          </span>{" "}
          {/* UPDATED: This now correctly displays the financial year from Redux */}
          <span style={{ marginLeft: "8px" }}>
            (Financial Year: {selectedYear})
          </span>
        </Row>

        <Tabs activeKey={activeTab} items={items} onChange={onChange} />
      </div>
      <Card><DataTable columns={columns} dataSource={FilterData} loading={loading} /></Card>
      <ModalDisplay
        isModalVisible={modalVisible}
        selectedPolicy={selectedPolicy}
        handleModalClose={handleModalClose}
      />
    </div>
  );
};

export default PolicyFeatures;
